(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-faq"] && !Shopify.designMode) return;
  try {
    
  /*
    <faq-cards> — progressively enhances the native <details> rows inside every
    FAQ card with a smooth open/close motion (height + fade), mirroring the
    Concept-style accordion used elsewhere in the theme. Rows stay fully
    functional without JS via the underlying <details>/<summary>.
  */
  if (!customElements.get('faq-cards')) {
    class FaqCards extends HTMLElement {
      connectedCallback() {
        this.classList.add('about-faq__cards--ready');
        this.rows = Array.from(this.querySelectorAll('.faq-row'));
        this.rows.forEach((row) => {
          const summary = row.querySelector('summary');
          summary.addEventListener('click', (event) => this.onSummaryClick(event, row));
        });
      }

      get motionReduced() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      // Exclusive accordion: when on (default), opening a row closes the others.
      // Turned off via data-single-open="false" so multiple rows can stay open.
      get singleOpen() {
        return this.dataset.singleOpen !== 'false';
      }

      onSummaryClick(event, row) {
        event.preventDefault();
        if (row.dataset.animating === 'true') return;
        row.open ? this.collapse(row) : this.expand(row);
      }

      expand(row) {
        const summary = row.querySelector('summary');
        const body = row.querySelector('.faq-row__body');

        if (this.singleOpen) {
          this.rows.forEach((other) => {
            if (other !== row && other.open && other.dataset.animating !== 'true') {
              this.collapse(other);
            }
          });
        }

        row.setAttribute('open', '');
        row.setAttribute('aria-expanded', 'true');

        if (this.motionReduced) return;

        row.dataset.animating = 'true';
        row.style.overflow = 'hidden';

        const startHeight = summary.offsetHeight;
        const endHeight = row.scrollHeight;

        const heightAnim = row.animate(
          [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
          { duration: 250, easing: 'ease' }
        );

        body.animate(
          [
            { opacity: 0, transform: 'translateY(10px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 150, delay: 100, easing: 'ease', fill: 'backwards' }
        );

        heightAnim.finished.then(() => this.reset(row)).catch(() => this.reset(row));
      }

      collapse(row) {
        const summary = row.querySelector('summary');
        const body = row.querySelector('.faq-row__body');

        row.setAttribute('aria-expanded', 'false');

        if (this.motionReduced) {
          row.removeAttribute('open');
          return;
        }

        row.dataset.animating = 'true';
        row.style.overflow = 'hidden';

        const startHeight = row.offsetHeight;
        const endHeight = summary.offsetHeight;

        // fill: 'forwards' keeps the body faded out for the rest of the height
        // collapse — without it the text snaps back to full opacity and flickers.
        body.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 150, easing: 'ease', fill: 'forwards' });

        const heightAnim = row.animate(
          [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
          { duration: 250, easing: 'ease' }
        );

        heightAnim.finished
          .then(() => {
            row.removeAttribute('open');
            this.reset(row);
          })
          .catch(() => {
            row.removeAttribute('open');
            this.reset(row);
          });
      }

      reset(row) {
        row.style.height = 'auto';
        row.style.overflow = '';
        // Clear the persisted (fill: forwards) fade so the body returns to its
        // default opacity for the next open.
        row.querySelector('.faq-row__body')?.getAnimations().forEach((a) => a.cancel());
        delete row.dataset.animating;
      }
    }

    customElements.define('faq-cards', FaqCards);
  }

  /*
    Keep the sticky right column clear of a sticky header: measure the pinned
    header's height and expose it as --about-faq-header-offset on each section.
    Falls back to 0 when the header isn't sticky, so the column just uses the
    configured top gap. Re-measured on resize.
  */
  (function () {
    function syncHeaderOffset() {
      var header = document.querySelector('[data-header-sticky]');
      var height = header ? Math.round(header.getBoundingClientRect().height) : 0;
      document.querySelectorAll('.about-faq').forEach(function (section) {
        section.style.setProperty('--about-faq-header-offset', height + 'px');
      });
    }

    if (document.querySelector('.about-faq')) {
      syncHeaderOffset();
      window.addEventListener('resize', syncHeaderOffset);
      window.addEventListener('load', syncHeaderOffset);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Reserve the bar's exact height on <body> so the fixed bar never overlaps
       the page content (CSS holds a sensible default until this runs). */
    var bar = document.querySelector('.ann');
    if (bar) {
      var setAnnHeight = function () {
        document.documentElement.style.setProperty('--ann-h', bar.offsetHeight + 'px');
      };
      setAnnHeight();
      if (window.ResizeObserver) {
        new ResizeObserver(setAnnHeight).observe(bar);
      } else {
        window.addEventListener('resize', setAnnHeight);
      }
    }

    /* One controller per pill: rotation + single-pass marquee.
       - Fitting messages: centred, rotate on the autoplay timer.
       - Overflowing messages (`.is-marquee`): start at the leading edge, hold,
         scroll once fully out; `animationend` then advances to the next
         message (or replays when there's nothing else to show). */
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var canHover = window.matchMedia('(hover: hover)');

    document.querySelectorAll('[data-ann-carousel]').forEach(function (root) {
      var box = root.querySelector('.ann__messages');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ann-slide]'));
      if (!box || !slides.length) return;

      var PX_PER_SECOND = 40;
      var multi = root.hasAttribute('data-ann-multi') && slides.length > 1;
      var autoplay = root.hasAttribute('data-ann-autoplay');
      var speed = parseInt(root.getAttribute('data-ann-speed'), 10) || 5000;
      var index = 0;
      var timer = null;

      function isMarquee(slide) { return slide.classList.contains('is-marquee'); }

      function measure() {
        var available = box.clientWidth;
        slides.forEach(function (slide) {
          var text = slide.querySelector('[data-ann-text]');
          if (!text) return;
          var width = text.getBoundingClientRect().width;
          var overflowing = !reducedMotion.matches && width > available + 1;
          slide.classList.toggle('is-marquee', overflowing);
          if (overflowing) {
            slide.style.setProperty('--ann-marquee-dur', (width / PX_PER_SECOND).toFixed(2) + 's');
          } else {
            slide.classList.remove('is-running');
            slide.style.removeProperty('--ann-marquee-dur');
          }
        });
        restart();
      }

      /* Replay the active slide's scroll from the start. */
      function restart() {
        var active = slides[index];
        slides.forEach(function (s) { if (s !== active) s.classList.remove('is-running'); });
        active.classList.remove('is-running');
        if (!isMarquee(active)) return;
        void active.offsetWidth;
        active.classList.add('is-running');
      }

      function stop() {
        if (timer) { clearTimeout(timer); timer = null; }
      }

      /* Marquee slides advance on animationend; fitting slides on the timer. */
      function schedule() {
        stop();
        if (!autoplay || !multi || isMarquee(slides[index])) return;
        timer = setTimeout(function () { show(index + 1); }, speed);
      }

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        restart();
        schedule();
      }

      slides.forEach(function (slide) {
        var track = slide.querySelector('[data-ann-track]');
        if (!track) return;
        track.addEventListener('animationend', function () {
          if (slide !== slides[index]) return;
          if (autoplay && multi) {
            slide.classList.add('is-gone');
            void slide.offsetWidth;
            show(index + 1);
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { slide.classList.remove('is-gone'); });
            });
            return;
          }
          restart();
        });
      });

      var prev = root.querySelector('[data-ann-prev]');
      var next = root.querySelector('[data-ann-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });

      if (canHover.matches) {
        root.addEventListener('mouseenter', function () { stop(); root.classList.add('is-paused'); });
        root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); schedule(); });
      }

      measure();
      if (window.ResizeObserver) {
        new ResizeObserver(measure).observe(box);
      } else {
        window.addEventListener('resize', measure);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      show(0);
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["badge-grid"] && !Shopify.designMode) return;
  try {
    
  /*
    <badge-carousel> — turns the badge row into a draggable horizontal scroller
    with prev/next arrows (Figma 1:3983). Built on native overflow scrolling:
      - pointer drag scrubs scrollLeft (desktop); touch keeps native momentum
      - arrows page by the visible width and disable at each end
      - arrows hide entirely when the track doesn't overflow
    Fully usable without JS (native scroll); JS only enhances.
  */
  if (!customElements.get('badge-carousel')) {
    class BadgeCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prevBtn = this.querySelector('[data-dir="prev"]');
        this.nextBtn = this.querySelector('[data-dir="next"]');
        if (!this.track) return;

        this.classList.add('badge-grid__carousel--ready');

        this.onScroll = this.updateArrows.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.page(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.page(1));

        this.bindDrag();

        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.track);

        this.updateArrows();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      get maxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      page(direction) {
        // Scroll by ~90% of the visible width so a partial card stays as an anchor.
        const amount = Math.round(this.track.clientWidth * 0.9);
        this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      updateArrows() {
        const overflows = this.maxScroll > 1;
        this.classList.toggle('badge-grid__carousel--static', !overflows);
        if (!overflows) return;

        const x = this.track.scrollLeft;
        if (this.prevBtn) this.prevBtn.disabled = x <= 1;
        if (this.nextBtn) this.nextBtn.disabled = x >= this.maxScroll - 1;
      }

      bindDrag() {
        if (!window.matchMedia('(hover: hover)').matches) return; // touch keeps native scroll

        let startX = 0;
        let startScroll = 0;
        let dragging = false;
        let moved = false;

        const onMove = (event) => {
          if (!dragging) return;
          const dx = event.clientX - startX;
          if (Math.abs(dx) > 3) moved = true;
          this.track.scrollLeft = startScroll - dx;
        };

        const onUp = (event) => {
          if (!dragging) return;
          dragging = false;
          this.classList.remove('badge-grid__carousel--dragging');
          try { this.track.releasePointerCapture(event.pointerId); } catch (e) { /* no-op */ }
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', onUp);
          // Swallow the click that follows a real drag so cards don't fire it
          if (moved) {
            const swallow = (e) => { e.stopPropagation(); e.preventDefault(); };
            this.track.addEventListener('click', swallow, { capture: true, once: true });
            setTimeout(() => this.track.removeEventListener('click', swallow, { capture: true }), 0);
          }
        };

        this.track.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          dragging = true;
          moved = false;
          startX = event.clientX;
          startScroll = this.track.scrollLeft;
          this.classList.add('badge-grid__carousel--dragging');
          try { this.track.setPointerCapture(event.pointerId); } catch (e) { /* no-op */ }
          window.addEventListener('pointermove', onMove);
          window.addEventListener('pointerup', onUp);
        });

        this.track.addEventListener('dragstart', (event) => event.preventDefault());
      }
    }

    customElements.define('badge-carousel', BadgeCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  /*
    <contact-map> — renders a Google Map via the Google Maps JavaScript API.
    The API library is loaded once per page (shared promise on window) no matter
    how many maps are on the page. Without an API key, the static fallback link
    is left in place so the section still works. Re-inits cleanly in the theme
    editor because each instance owns its own map.
  */
  if (!customElements.get('contact-map')) {
    const loadGoogleMaps = (key) => {
      if (window.__alifeMapsPromise) return window.__alifeMapsPromise;
      window.__alifeMapsPromise = new Promise((resolve, reject) => {
        window.__alifeMapsInit = () => resolve(window.google && window.google.maps);
        const script = document.createElement('script');
        script.src =
          'https://maps.googleapis.com/maps/api/js?key=' +
          encodeURIComponent(key) +
          '&loading=async&callback=__alifeMapsInit';
        script.async = true;
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return window.__alifeMapsPromise;
    };

    customElements.define(
      'contact-map',
      class extends HTMLElement {
        connectedCallback() {
          this.canvas = this.querySelector('[data-map-canvas]');
          const key = this.dataset.apiKey;
          const lat = parseFloat(this.dataset.lat);
          const lng = parseFloat(this.dataset.lng);

          // No key or no valid coordinates → keep the fallback link.
          if (!key || !this.canvas || Number.isNaN(lat) || Number.isNaN(lng)) return;

          loadGoogleMaps(key)
            .then((maps) => maps && this.render(maps, { lat, lng }))
            .catch(() => {
              /* Loading failed (bad key, offline) — fallback link stays visible. */
            });
        }

        get styles() {
          if (!this.dataset.style) return undefined;
          try {
            return JSON.parse(this.dataset.style);
          } catch (e) {
            return undefined;
          }
        }

        render(maps, center) {
          const map = new maps.Map(this.canvas, {
            center,
            zoom: parseInt(this.dataset.zoom, 10) || 14,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: true,
            gestureHandling: 'cooperative',
            styles: this.styles,
          });

          new maps.Marker({
            position: center,
            map,
            title: this.dataset.title || '',
          });

          this.classList.add('contact__map--ready');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  /*
    <faq-accordion> — progressively enhances native <details> rows with the same
    open/close motion as the Concept theme's accordion-details:
      open  → height: summary → full (0.25s ease), content fades + slides up 10px (0.15s)
      close → content fades out (0.15s), height: full → summary (0.25s ease)
    Built on the native Web Animations API (no Motion dependency). Rows stay fully
    functional without JS via the underlying <details>/<summary>.
  */
  if (!customElements.get('faq-accordion')) {
    class FaqAccordion extends HTMLElement {
      constructor() {
        super();
        this.items = Array.from(this.querySelectorAll('.faq-item'));
      }

      connectedCallback() {
        this.classList.add('faq-accordion--ready');
        this.items.forEach((item) => {
          const summary = item.querySelector('summary');
          summary.addEventListener('click', (event) => this.onSummaryClick(event, item));
        });
      }

      get motionReduced() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      // Exclusive accordion: when on (default), opening a row closes the others.
      // Turned off via data-single-open="false" so multiple rows can stay open.
      get singleOpen() {
        return this.dataset.singleOpen !== 'false';
      }

      onSummaryClick(event, item) {
        event.preventDefault();
        if (item.dataset.animating === 'true') return;
        item.open ? this.collapse(item) : this.expand(item);
      }

      expand(item) {
        const summary = item.querySelector('summary');
        const content = item.querySelector('.faq-item__content');

        if (this.singleOpen) {
          this.items.forEach((other) => {
            if (other !== item && other.open && other.dataset.animating !== 'true') {
              this.collapse(other);
            }
          });
        }

        item.setAttribute('open', '');
        item.setAttribute('aria-expanded', 'true');

        if (this.motionReduced) return;

        item.dataset.animating = 'true';
        item.style.overflow = 'hidden';

        const startHeight = summary.offsetHeight;
        const endHeight = item.scrollHeight;

        const heightAnim = item.animate(
          [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
          { duration: 250, easing: 'ease' }
        );

        content.animate(
          [
            { opacity: 0, transform: 'translateY(10px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 150, delay: 100, easing: 'ease', fill: 'backwards' }
        );

        heightAnim.finished.then(() => this.reset(item)).catch(() => this.reset(item));
      }

      collapse(item) {
        const summary = item.querySelector('summary');
        const content = item.querySelector('.faq-item__content');

        item.setAttribute('aria-expanded', 'false');

        if (this.motionReduced) {
          item.removeAttribute('open');
          return;
        }

        item.dataset.animating = 'true';
        item.style.overflow = 'hidden';

        const startHeight = item.offsetHeight;
        const endHeight = summary.offsetHeight;

        // fill: 'forwards' keeps the content faded out for the rest of the height
        // collapse — without it the text snaps back to full opacity and flickers.
        content.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 150, easing: 'ease', fill: 'forwards' });

        const heightAnim = item.animate(
          [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
          { duration: 250, easing: 'ease' }
        );

        heightAnim.finished
          .then(() => {
            item.removeAttribute('open');
            this.reset(item);
          })
          .catch(() => {
            item.removeAttribute('open');
            this.reset(item);
          });
      }

      reset(item) {
        item.style.height = 'auto';
        item.style.overflow = '';
        // Clear the persisted (fill: forwards) fade so the content returns to its
        // default opacity for the next open.
        item.querySelector('.faq-item__content')?.getAnimations().forEach((a) => a.cancel());
        delete item.dataset.animating;
      }
    }

    customElements.define('faq-accordion', FaqAccordion);
  }

  /*
    <faq-buttons> — same cursor-blob hover as the shared <hover-buttons>
    (assets/hover-button.js): a circular fill grows out of the exact point the
    cursor crossed the edge, and shrinks back toward the exit point on leave.
    Text colour inverts via CSS. Built on the Web Animations API (no Motion
    dep). Skipped on touch / no-hover pointers.
  */
  if (!customElements.get('faq-buttons')) {
    class FaqButtons extends HTMLElement {
      connectedCallback() {
        if (!window.matchMedia('(hover: hover)').matches) return;

        this.classList.add('faq-buttons--ready');

        this.querySelectorAll('.faq-button').forEach((button) => {
          const fill = button.querySelector('[data-fill]');
          if (!fill) return;
          button.addEventListener('mouseenter', (e) => this.blob(button, fill, e, true));
          button.addEventListener('mouseleave', (e) => this.blob(button, fill, e, false));
        });
      }

      // Grows via width/height, NOT transform — a composited transform layer
      // is clipped slightly differently than the painted background at the
      // rounded edge, leaving a ~1px ring of the colour beneath (same
      // reasoning as the shared hover-button.js).
      blob(button, fill, event, entering) {
        const rect = button.getBoundingClientRect();
        const px = event.clientX - rect.left;
        const py = event.clientY - rect.top;
        fill.style.left = `${px}px`;
        fill.style.top = `${py}px`;

        if (fill._anim) {
          try { fill._anim.commitStyles(); } catch (e) { /* no-op */ }
          fill._anim.cancel();
        }
        const far = Math.max(
          Math.hypot(px, py),
          Math.hypot(rect.width - px, py),
          Math.hypot(px, rect.height - py),
          Math.hypot(rect.width - px, rect.height - py)
        );
        const d = entering ? Math.ceil(far * 2 * 1.15) : 0;
        fill._anim = fill.animate(
          [{ width: `${d}px`, height: `${d}px` }],
          { duration: 450, easing: entering ? 'cubic-bezier(0.5, 0, 1, 1)' : 'ease', fill: 'forwards' }
        );
      }
    }

    customElements.define('faq-buttons', FaqButtons);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.header').forEach(function (header) {
      /* Sticky: flag when the header is pinned to the top, so the panel's
         top corners can flatten. The sticky element is the .shopify-section
         wrapper; it reads top: 0 once pinned. */
      if (header.hasAttribute('data-header-sticky')) {
        var sticky = header.closest('.header-section') || header;
        var ticking = false;
        var sync = function () {
          ticking = false;
          header.toggleAttribute('data-stuck', sticky.getBoundingClientRect().top <= 0);
          header.toggleAttribute('data-scrolled', window.scrollY > 30);
        };
        window.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(sync);
        }, { passive: true });
        sync();
      }

      /* The mobile drawer drives itself — see assets/menu-drawer.js. It syncs
         aria-expanded on [aria-controls="MenuDrawer"], which is what animates
         the hamburger into an X. */

      /* Desktop dropdowns: only one open at a time + close on outside click / Escape */
      var dropdowns = header.querySelectorAll('[data-header-dropdown]');

      dropdowns.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          dropdowns.forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
        });
      });

      document.addEventListener('click', function (e) {
        dropdowns.forEach(function (d) {
          if (d.open && !d.contains(e.target)) d.removeAttribute('open');
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        dropdowns.forEach(function (d) { d.removeAttribute('open'); });
      });

      /* Account popup: the X button closes its <details> */
      header.querySelectorAll('[data-popup-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var details = btn.closest('details');
          if (details) details.removeAttribute('open');
        });
      });
    });

    /* Live cart count via the Cart Ajax API (updates after add-to-cart elsewhere) */
    document.addEventListener('cart:updated', function (e) {
      var count = e.detail && e.detail.item_count;
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });
    });

    /* ----------------------------------------------------------------------
       Style the Shopify account popup's heading + close button.
       These live inside <shopify-account>'s shadow root as .account__heading
       and .account__close, but Shopify gives them NO part="" attribute, so
       ::part() / outer CSS cannot reach them. The only way in is to inject a
       <style> into the shadow root itself — which works only if Shopify left
       the root "open". If it's closed, shadowRoot is null and this no-ops. */
    var ACCOUNT_SHADOW_CSS = [
      /* Wider popup (Shopify default ~360px) + a cream card with a border. */
      ':host { --app-width: 460px !important; }',
      '.dialog {',
      '  width: min(460px, 94vw) !important;',
      '  max-width: min(460px, 94vw) !important;',
      '  border: 1px solid var(--color-border, #e6e6e6) !important;',
      '}',

      '.account__heading {',
      "  font-family: var(--font-heading-family, 'Lastik', Georgia, serif) !important;",
      '  font-size: 2rem !important;',          /* 32px — matches .faq-item__question */
      '  line-height: 1.25 !important;',
      '  font-weight: 400 !important;',
      '  letter-spacing: -0.02em !important;',
      '  text-transform: none !important;',
      '}',

      /* Close (X): circular, thin border, with a blob that GROWS from the
         centre on hover (CSS-only cousin of the cursor-anchored blob the other
         buttons use — no pointer coords inside this sealed shadow root) while
         the X rotates and inverts. Pseudo-element = no extra DOM needed. */
      '.account__close {',
      '  position: relative !important;',
      '  width: 48px !important;',
      '  height: 48px !important;',
      '  min-height: 48px !important;',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  background: transparent !important;',
      '  border: 0 !important;',
      '  border-radius: 999px !important;',
      '  overflow: hidden !important;',
      '  color: var(--color-text, #000) !important;',
      '}',
      '.account__close::before {',
      "  content: '' !important;",
      '  position: absolute !important;',
      '  inset-block-start: 50% !important;',
      '  inset-inline-start: 50% !important;',
      '  width: 150% !important;',
      '  height: 150% !important;',
      '  border-radius: 50% !important;',
      '  background: var(--color-text, #000) !important;',
      '  transform: translate(-50%, -50%) scale(0) !important;',
      '  transition: transform 0.45s cubic-bezier(0.3, 1, 0.3, 1) !important;',
      '  pointer-events: none !important;',
      '  z-index: 0 !important;',
      '}',
      '.account__close > svg {',
      '  position: relative !important;',
      '  z-index: 1 !important;',
      '  transition: transform 0.5s cubic-bezier(0.3, 1, 0.3, 1),',
      '              color 0.5s cubic-bezier(0.3, 1, 0.3, 1) !important;',
      '}',
      '.account__close:hover::before {',
      '  transform: translate(-50%, -50%) scale(1) !important;',
      '}',
      '.account__close:hover > svg {',
      '  transform: rotate(90deg) !important;',
      '  color: var(--color-background, #fff) !important;',
      '}'
    ].join('\n');

    function injectAccountStyles(root) {
      if (!root || root.querySelector('style[data-alife-account]')) return;
      var style = document.createElement('style');
      style.setAttribute('data-alife-account', '');
      style.textContent = ACCOUNT_SHADOW_CSS;
      root.appendChild(style);
    }

    function styleAccountPopups() {
      document.querySelectorAll('shopify-account').forEach(function (el) {
        injectAccountStyles(el.shadowRoot);
      });
    }

    /* The component upgrades + attaches its shadow root asynchronously, so
       retry for a few seconds, then keep watching for late-added instances. */
    var tries = 0;
    var poll = setInterval(function () {
      styleAccountPopups();
      if (++tries >= 40) clearInterval(poll); /* ~10s */
    }, 250);

    if (window.MutationObserver) {
      new MutationObserver(styleAccountPopups).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  /*
    <product-buy> — variant selection + add-to-cart / checkout for the product
    page. Reads the inlined variant data, reflects the chosen options into the
    price, availability, the hidden `id` input and the URL, and handles the two
    CTAs. Everything degrades to the native product <form> without JS.
  */
  if (!customElements.get('product-buy')) {
    customElements.define('product-buy', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-product-form]');
        if (!this.form) return;

        this.variants = this.readJSON('[data-product-variants]') || [];
        this.prices = this.readJSON('[data-variant-prices]') || {};
        this.idInput = this.querySelector('[data-variant-id]');
        this.priceEl = this.querySelector('[data-price]');
        this.compareEl = this.querySelector('[data-compare]');
        this.unitEl = this.querySelector('[data-price-unit]');
        this.addButton = this.querySelector('[data-add-button]');
        this.addText = this.querySelector('[data-add-text]');
        this.checkoutButton = this.querySelector('[data-checkout-button]');

        this.sticky = this.querySelector('[data-product-sticky]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.stickyUnit = this.querySelector('[data-sticky-price-unit]');
        this.stickyAdd = this.querySelector('[data-sticky-add]');

        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-option-position]')) this.onOptionChange();
        });

        // Quantity stepper (mobile): −/+ adjust the real name="quantity"
        // input, so every add path carries it for free.
        this.qtyInput = this.querySelector('[data-qty-input]');
        this.addEventListener('click', (event) => {
          const step = event.target.closest('[data-qty-minus], [data-qty-plus]');
          if (!step || !this.qtyInput) return;
          const next = (parseInt(this.qtyInput.value, 10) || 1) + (step.matches('[data-qty-plus]') ? 1 : -1);
          this.qtyInput.value = Math.max(1, next);
        });

        this.checkoutButton?.addEventListener('click', () => this.checkout());

        this.setupSticky();
      }

      /* Wire the sticky overlay bar: pill clicks proxy to the real radios, the
         add button proxies to the form submit, and an IntersectionObserver
         reveals the bar once the main CTAs scroll out of the top of the view. */
      disconnectedCallback() {
        // The sticky bar was relocated to <body>; remove it with the component.
        this.observer?.disconnect();
        this.sticky?.remove();
      }

      setupSticky() {
        if (!this.sticky) return;

        // Lift the bar to <body> so it escapes the product section's stacking
        // context — otherwise later sections paint over it no matter the z-index.
        document.body.appendChild(this.sticky);

        this.sticky.addEventListener('click', (event) => {
          const pill = event.target.closest('[data-sticky-option-position]');
          if (pill) { this.onStickyPill(pill); return; }
          if (event.target.closest('[data-sticky-add]') && !this.addButton?.disabled) {
            // The real submit lights up the form button; mirror the loading
            // state on the sticky pill the visitor actually clicked. The cart
            // drawer's stopAll() clears both when the AJAX add settles.
            window.theme?.buttonLoader?.start(this.stickyAdd);
            this.addButton.click();
          }
        });

        const anchor = this.querySelector('.product__actions');
        if (anchor && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.sticky.classList.toggle('is-visible', show);
            this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          }, { threshold: 0 });
          this.observer.observe(anchor);
        }
      }

      onStickyPill(pill) {
        const position = pill.dataset.stickyOptionPosition;
        const value = pill.dataset.stickyValue;
        this.querySelectorAll('[data-option-position="' + position + '"]').forEach((radio) => {
          if (radio.value === value && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      syncSticky(variant) {
        if (!this.sticky) return;
        const meta = variant && this.prices[variant.id];
        if (this.stickyPrice && meta) this.stickyPrice.textContent = meta.price;
        if (this.stickyUnit) {
          const unit = meta && meta.unit;
          this.stickyUnit.textContent = unit || '';
          this.stickyUnit.hidden = !unit;
        }

        const chosen = this.selectedOptions;
        this.sticky.querySelectorAll('[data-sticky-option-position]').forEach((pill) => {
          const index = Number(pill.dataset.stickyOptionPosition) - 1;
          const active = pill.dataset.stickyValue === chosen[index];
          pill.classList.toggle('is-active', active);
          pill.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      readJSON(selector) {
        const node = this.querySelector(selector);
        if (!node) return null;
        try { return JSON.parse(node.textContent); } catch (e) { return null; }
      }

      get selectedOptions() {
        return Array.from(this.querySelectorAll('[data-option-position]:checked'))
          .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
          .map((input) => input.value);
      }

      onOptionChange() {
        const chosen = this.selectedOptions;
        const variant = this.variants.find((v) =>
          v.options.length === chosen.length && v.options.every((opt, i) => opt === chosen[i])
        );
        this.currentVariant = variant || null;
        this.render(variant);
      }

      render(variant) {
        this.syncSticky(variant);
        if (!variant) {
          this.setAvailable(false);
          return;
        }

        if (this.idInput) this.idInput.value = variant.id;

        const meta = this.prices[variant.id];
        if (meta && this.priceEl) this.priceEl.textContent = meta.price;
        if (this.unitEl) {
          const unit = meta && meta.unit;
          this.unitEl.textContent = unit || '';
          this.unitEl.hidden = !unit;
        }
        if (this.compareEl) {
          if (meta && meta.compare) {
            this.compareEl.textContent = meta.compare;
            this.compareEl.hidden = false;
          } else {
            this.compareEl.hidden = true;
          }
        }

        this.setAvailable(variant.available);

        if (variant.id && window.history.replaceState) {
          const url = new URL(this.dataset.url, window.location.origin);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      setAvailable(available) {
        const disabled = !available;
        if (this.addButton) {
          this.addButton.disabled = disabled;
          if (this.addText) {
            this.addText.textContent = available
              ? this.addButton.dataset.addLabel
              : this.addButton.dataset.soldOutLabel;
          }
        }
        if (this.checkoutButton) this.checkoutButton.disabled = disabled;
        if (this.stickyAdd) this.stickyAdd.disabled = disabled;
      }

      checkout() {
        if (this.checkoutButton?.disabled || this.checkoutButton?.getAttribute('aria-busy') === 'true') return;
        const id = this.idInput?.value;
        if (!id) { this.form.submit(); return; }

        // Loader instead of `disabled`: aria-busy blocks re-clicks via CSS
        // pointer-events while keeping the pill's colors for the dots.
        window.theme?.buttonLoader?.start(this.checkoutButton);
        const quantity = Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] })
        })
          .then((res) => res.json())
          .then(() => { window.location.href = '/checkout'; })
          .catch(() => { window.theme?.buttonLoader?.stop(this.checkoutButton); this.form.submit(); });
      }
    });
  }

  /*
    <product-accordion> — smooth open/close for the native <details> info rows
    (height + fade), matching the FAQ accordion. Fully functional without JS.
  */
  if (!customElements.get('product-accordion')) {
    customElements.define('product-accordion', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.product-acc').forEach((row) => {
          row.querySelector('summary')?.addEventListener('click', (e) => this.onClick(e, row));
        });
      }

      get motionReduced() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      onClick(event, row) {
        event.preventDefault();
        if (row.dataset.animating === 'true') return;
        row.open ? this.collapse(row) : this.expand(row);
      }

      expand(row) {
        // Single-open: collapse any other row that is currently open.
        this.querySelectorAll('.product-acc[open]').forEach((other) => {
          if (other !== row) this.collapse(other);
        });
        const summary = row.querySelector('summary');
        const body = row.querySelector('.product-acc__body');
        row.setAttribute('open', '');
        row.setAttribute('aria-expanded', 'true');
        if (this.motionReduced) return;

        row.dataset.animating = 'true';
        row.style.overflow = 'hidden';
        const anim = row.animate(
          [{ height: summary.offsetHeight + 'px' }, { height: row.scrollHeight + 'px' }],
          { duration: 250, easing: 'ease' }
        );
        body.animate(
          [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 150, delay: 100, easing: 'ease', fill: 'backwards' }
        );
        anim.finished.then(() => this.reset(row)).catch(() => this.reset(row));
      }

      collapse(row) {
        const summary = row.querySelector('summary');
        const body = row.querySelector('.product-acc__body');
        row.setAttribute('aria-expanded', 'false');
        if (this.motionReduced) { row.removeAttribute('open'); return; }

        row.dataset.animating = 'true';
        row.classList.add('is-closing');
        row.style.overflow = 'hidden';
        // fill: 'forwards' keeps the body faded out for the rest of the height
        // collapse — without it the text snaps back to full opacity and flickers.
        body.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 150, easing: 'ease', fill: 'forwards' });
        const anim = row.animate(
          [{ height: row.offsetHeight + 'px' }, { height: summary.offsetHeight + 'px' }],
          { duration: 250, easing: 'ease' }
        );
        anim.finished
          .then(() => { row.removeAttribute('open'); this.reset(row); })
          .catch(() => { row.removeAttribute('open'); this.reset(row); });
      }

      reset(row) {
        row.classList.remove('is-closing');
        row.style.height = 'auto';
        row.style.overflow = '';
        // Clear the persisted (fill: forwards) fade so the body returns to its
        // default opacity for the next open.
        row.querySelector('.product-acc__body')?.getAnimations().forEach((a) => a.cancel());
        delete row.dataset.animating;
      }
    });
  }

  /*
    <product-gallery> — the product photo gallery. Bento is pure CSS. In slider
    mode (the thumbnails layout, or phones with the slider setting) the track is
    a native scroll-snap strip and this keeps the thumbnails, dots and arrows in
    step with it. The arrows loop: next on the last photo goes to the first.
  */
  if (!customElements.get('product-gallery')) {
    const SCROLL_MIN_MS = 380;
    const SCROLL_MAX_MS = 650;
    // A mouse press becomes a drag after this many pixels…
    const DRAG_THRESHOLD = 6;
    // …and a drag this share of the photo's width moves to the next photo.
    const SWIPE_RATIO = 0.12;

    customElements.define('product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gallery-track]');
        if (!this.track) return;

        this.slides = Array.from(this.track.querySelectorAll('[data-gallery-slide]'));
        this.indicators = Array.from(this.querySelectorAll('.product-gallery__thumbs [data-gallery-action="show"], .product-gallery__dots [data-gallery-action="show"]'));
        this.index = 0;
        this.scrollFrames = new Map();
        this.onDragMove = (event) => this.dragMove(event);
        this.onDragEnd = (event) => this.dragEnd(event);

        this.onTrackScroll = this.perFrame(() => this.syncFromScroll());
        this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
        this.track.addEventListener('pointerdown', (event) => this.dragStart(event));
        this.track.addEventListener('wheel', () => this.stopScroll(this.track), { passive: true });
        this.track.addEventListener('dragstart', (event) => event.preventDefault());
        this.addEventListener('click', (event) => this.onClick(event));
        this.watchLeadHeight();
      }

      disconnectedCallback() {
        this.leadObserver?.disconnect();
        clearTimeout(this.targetTimer);
        this.scrollFrames?.forEach((frame) => cancelAnimationFrame(frame));
        this.removeDragListeners();
      }

      // Shares the height of the first block (the 3-photo bento, or the whole
      // slider) with the info column, so it ends where that block ends.
      watchLeadHeight() {
        const layout = this.closest('.product__layout');
        if (!layout || !('ResizeObserver' in window)) return;
        const lead = this.classList.contains('product-gallery--bento') ? this.querySelector('.product-gallery__group') : this;
        if (!lead) return;

        this.leadObserver = new ResizeObserver(() => {
          layout.style.setProperty('--product-lead-height', `${Math.round(lead.getBoundingClientRect().height)}px`);
        });
        this.leadObserver.observe(lead);
      }

      onClick(event) {
        const control = event.target.closest('[data-gallery-action]');
        if (!control) return;

        switch (control.dataset.galleryAction) {
          case 'show':
            this.goTo(Number(control.dataset.index));
            break;
          case 'prev':
            this.goTo(this.wrap(this.index - 1));
            break;
          case 'next':
            this.goTo(this.wrap(this.index + 1));
            break;
        }
      }

      /* ---- In-page slider ---- */
      goTo(index) {
        const slide = this.slides[index];
        if (!slide) return;
        // The scroll passes the photos in between; hold the thumbnails and
        // dots on the target until it arrives (or a second has passed).
        this.targetIndex = index;
        clearTimeout(this.targetTimer);
        this.targetTimer = setTimeout(() => {
          this.targetIndex = null;
          this.syncFromScroll();
        }, 1000);
        this.animateScroll(this.track, { left: slide.offsetLeft });
        this.setIndex(index);
      }

      /* ---- Mouse drag (touch keeps native swiping) ---- */
      dragStart(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (this.track.scrollWidth <= this.track.clientWidth) return;
        this.stopScroll(this.track);
        this.targetIndex = null;
        this.drag = { startX: event.clientX, startLeft: this.track.scrollLeft, startIndex: this.index, moved: false };
        window.addEventListener('pointermove', this.onDragMove);
        window.addEventListener('pointerup', this.onDragEnd);
        window.addEventListener('pointercancel', this.onDragEnd);
      }

      dragMove(event) {
        const dx = event.clientX - this.drag.startX;
        if (!this.drag.moved && Math.abs(dx) < DRAG_THRESHOLD) return;
        if (!this.drag.moved) {
          this.drag.moved = true;
          this.track.style.scrollSnapType = 'none';
          this.classList.add('is-dragging');
        }
        this.track.scrollLeft = this.drag.startLeft - dx;
      }

      // Settle on the photo the drag points to: past the halfway mark that's
      // the nearest one, otherwise a short pull is enough to step one photo.
      dragEnd(event) {
        this.removeDragListeners();
        const drag = this.drag;
        this.drag = null;
        if (!drag?.moved) return;
        this.classList.remove('is-dragging');

        const dx = event.clientX - drag.startX;
        const nearest = this.nearest(this.track, this.slides);
        const pulledFar = Math.abs(dx) > this.track.clientWidth * SWIPE_RATIO;
        const step = dx < 0 ? 1 : -1;
        const target = nearest !== drag.startIndex || !pulledFar ? nearest : drag.startIndex + step;
        this.goTo(Math.min(Math.max(target, 0), this.slides.length - 1));
      }

      removeDragListeners() {
        window.removeEventListener('pointermove', this.onDragMove);
        window.removeEventListener('pointerup', this.onDragEnd);
        window.removeEventListener('pointercancel', this.onDragEnd);
      }

      syncFromScroll() {
        const index = this.nearest(this.track, this.slides);
        if (this.targetIndex != null && index !== this.targetIndex) return;
        this.targetIndex = null;
        if (index === this.index) return;
        this.setIndex(index);
      }

      // Past the last photo comes the first, and before the first the last.
      wrap(index) {
        const count = this.slides.length;
        return (index + count) % count;
      }

      setIndex(index) {
        this.index = index;
        this.indicators.forEach((button) => {
          const current = Number(button.dataset.index) === index;
          button.setAttribute('aria-current', current ? 'true' : 'false');
          if (current) this.revealThumb(button);
        });
      }

      /* Keep the active thumbnail visible in a long strip, without moving the page. */
      revealThumb(button) {
        const strip = button.parentElement;
        const overflows = strip && (strip.scrollWidth > strip.clientWidth || strip.scrollHeight > strip.clientHeight);
        if (!overflows) return;
        this.animateScroll(strip, {
          left: button.offsetLeft - (strip.clientWidth - button.offsetWidth) / 2,
          top: button.offsetTop - (strip.clientHeight - button.offsetHeight) / 2
        });
      }

      /* ---- Helpers ---- */

      // Eased scroll that looks the same in every browser (native smooth
      // scrolling jumps on snapping sliders in some). Snap is off while it runs.
      animateScroll(element, target) {
        this.stopScroll(element);
        const from = { left: element.scrollLeft, top: element.scrollTop };
        const to = {
          left: Math.min(Math.max(target.left, 0), element.scrollWidth - element.clientWidth),
          top: Math.min(Math.max(target.top ?? 0, 0), element.scrollHeight - element.clientHeight)
        };
        const distance = Math.max(Math.abs(to.left - from.left), Math.abs(to.top - from.top));
        if (distance < 1 || this.reducedMotion()) {
          element.scrollLeft = to.left;
          element.scrollTop = to.top;
          element.style.scrollSnapType = '';
          return;
        }

        const duration = Math.min(SCROLL_MAX_MS, SCROLL_MIN_MS + distance * 0.1);
        const startTime = performance.now();
        element.style.scrollSnapType = 'none';
        const frame = (now) => {
          const progress = Math.min(1, (now - startTime) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          element.scrollLeft = from.left + (to.left - from.left) * eased;
          element.scrollTop = from.top + (to.top - from.top) * eased;
          if (progress < 1) {
            this.scrollFrames.set(element, requestAnimationFrame(frame));
            return;
          }
          this.scrollFrames.delete(element);
          element.style.scrollSnapType = '';
        };
        this.scrollFrames.set(element, requestAnimationFrame(frame));
      }

      stopScroll(element) {
        const frame = this.scrollFrames.get(element);
        if (frame === undefined) return;
        cancelAnimationFrame(frame);
        this.scrollFrames.delete(element);
        element.style.scrollSnapType = '';
      }
      nearest(track, slides) {
        const left = track.scrollLeft;
        let best = 0;
        slides.forEach((slide, index) => {
          if (Math.abs(slide.offsetLeft - left) < Math.abs(slides[best].offsetLeft - left)) best = index;
        });
        return best;
      }

      perFrame(callback) {
        let queued = false;
        return () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => {
            queued = false;
            callback();
          });
        };
      }

      reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
    });
  }

  /* Keep the sticky info column clear of a sticky header. */
  (function () {
    function syncHeaderOffset() {
      var header = document.querySelector('[data-header-sticky]');
      var height = header ? Math.round(header.getBoundingClientRect().height) : 0;
      document.querySelectorAll('.product').forEach(function (section) {
        section.style.setProperty('--product-header-offset', height + 'px');
      });
    }
    if (document.querySelector('.product')) {
      syncHeaderOffset();
      window.addEventListener('resize', syncHeaderOffset);
      window.addEventListener('load', syncHeaderOffset);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-policy"] && !Shopify.designMode) return;
  try {
    
  /*
    Keep the sticky table of contents clear of the sticky navbar: measure the pinned
    header's height and expose it as --pp-header-offset on the section. Falls
    back to 0 when the header isn't sticky, so the column just uses the
    configured top gap. Mirrors the same helper in about-faq / main-product.
  */
  (function () {
    function syncPrivacyOffset() {
      var header = document.querySelector('[data-header-sticky]');
      var height = header ? Math.round(header.getBoundingClientRect().height) : 0;
      document.querySelectorAll('.privacy').forEach(function (section) {
        section.style.setProperty('--pp-header-offset', height + 'px');
      });
    }

    if (document.querySelector('.privacy')) {
      syncPrivacyOffset();
      window.addEventListener('resize', syncPrivacyOffset);
      window.addEventListener('load', syncPrivacyOffset);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cta-buy')) {
    customElements.define('cta-buy', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-product-form]');
        this.idInput = this.querySelector('[data-variant-id]');
        this.checkoutButton = this.querySelector('[data-checkout-button]');
        this.checkoutButton?.addEventListener('click', () => this.checkout());
      }

      checkout() {
        if (!this.form || this.checkoutButton?.disabled || this.checkoutButton?.getAttribute('aria-busy') === 'true') return;
        const id = this.idInput?.value;
        if (!id) { this.form.submit(); return; }
        // Loader instead of `disabled`: aria-busy blocks re-clicks via CSS
        // pointer-events while keeping the pill's colors for the dots.
        window.theme?.buttonLoader?.start(this.checkoutButton);
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then((res) => res.json())
          .then(() => { window.location.href = '/checkout'; })
          .catch(() => { window.theme?.buttonLoader?.stop(this.checkoutButton); this.form.submit(); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-policy"] && !Shopify.designMode) return;
  try {
    
  /*
    Keep the sticky contact card clear of the sticky navbar: measure the pinned
    header's height and expose it as --retp-header-offset on the section. Falls
    back to 0 when the header isn't sticky, so the column just uses the
    configured top gap. Mirrors the same helper in about-faq / main-product.
  */
  (function () {
    function syncReturnsOffset() {
      var header = document.querySelector('[data-header-sticky]');
      var height = header ? Math.round(header.getBoundingClientRect().height) : 0;
      document.querySelectorAll('.retp').forEach(function (section) {
        section.style.setProperty('--retp-header-offset', height + 'px');
      });
    }

    if (document.querySelector('.retp')) {
      syncReturnsOffset();
      window.addEventListener('resize', syncReturnsOffset);
      window.addEventListener('load', syncReturnsOffset);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["socials"] && !Shopify.designMode) return;
  try {
    
  /*
    <socials-gallery> — click/press-and-drag horizontal scrolling for the post
    gallery (desktop pointer only; native touch + trackpad scrolling is left
    untouched). A drag past a small threshold suppresses the card's click so
    dragging never accidentally opens a post. Fully functional without JS.

    With data-feed-url it also loads the latest Instagram posts from the
    Instafeed Feed API (https://docs.minttstudio.com/developer-api/docs/instafeed-api/developer-api)
    and swaps them in for the server-rendered cards. Any failure keeps those cards.
  */
  if (!customElements.get('socials-gallery')) {
    const FEED_CACHE_MS = 10 * 60 * 1000;
    const FEED_CACHE_PREFIX = 'socials-feed:v2:';
    const FEED_ALT_MAX = 120;
    const INSTAGRAM_LINK = /^https:\/\/(www\.)?instagram\.com\//;
    // A reel starts downloading when its card is this close to the viewport…
    const VIDEO_PRELOAD_MARGIN = '300px 0px';
    // …and plays while at least this much of it is on screen.
    const VIDEO_PLAY_RATIO = 0.5;

    const isHttps = (url) => typeof url === 'string' && url.startsWith('https://');

    // Reels stay as cover photos for reduced-motion and data-saver visitors.
    const videoAllowed = () =>
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData;

    const loadVideo = (video) => {
      if (video.getAttribute('src')) return;
      video.preload = 'auto';
      video.src = video.dataset.src;
    };

    // First caption line, shortened: the API gives no alt text for most posts.
    const altFor = (raw) => {
      const text = String(raw.alt_text || raw.caption?.text || '');
      const firstLine = text.split('\n')[0].trim();
      if (firstLine.length <= FEED_ALT_MAX) return firstLine;
      return `${firstLine.slice(0, FEED_ALT_MAX - 1).trimEnd()}…`;
    };

    // Keeps only what a card needs. The data comes from a third party, so links
    // must point at Instagram and photos must be https.
    const toPost = (raw) => {
      const image = raw?.images?.standard_resolution?.url;
      const video = raw?.videos?.standard_resolution?.url;
      const link = raw?.link;
      if (!isHttps(image)) return null;
      if (typeof link !== 'string' || !INSTAGRAM_LINK.test(link)) return null;
      return { image, link, alt: altFor(raw), video: isHttps(video) ? video : '' };
    };

    const requestFeed = async (url, apiKey) => {
      const response = await fetch(url, { headers: { 'X-API-Key': apiKey } });
      if (!response.ok) return null;
      return response.json();
    };

    const readCache = (key) => {
      try {
        const entry = JSON.parse(sessionStorage.getItem(key));
        if (!entry || !Array.isArray(entry.posts)) return null;
        if (Date.now() - entry.time > FEED_CACHE_MS) return null;
        return entry.posts;
      } catch (error) {
        return null;
      }
    };

    const writeCache = (key, posts) => {
      try {
        sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), posts }));
      } catch (error) {
        /* storage blocked or full: the feed still renders, just uncached */
      }
    };

    const showCard = (card) => {
      card.style.opacity = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      card.animate({ opacity: [0, 1] }, { duration: 400, easing: 'ease-out' });
    };

    class SocialsGallery extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.socials__gallery');
        if (!this.scroller) return;

        this.isDown = false;
        this.moved = false;
        this.startX = 0;
        this.startScroll = 0;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onClick = this.onClick.bind(this);

        this.scroller.addEventListener('pointerdown', this.onPointerDown);
        this.scroller.addEventListener('click', this.onClick, true);
        this.classList.add('socials__viewport--ready');
        this.watchFeed();
      }

      disconnectedCallback() {
        this.feedObserver?.disconnect();
        this.videoLoader?.disconnect();
        this.videoPlayer?.disconnect();
      }

      // Fetch only once the gallery nears the viewport, so page load stays light.
      watchFeed() {
        if (!this.dataset.feedUrl) return;
        this.feedObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.feedObserver.disconnect();
            this.loadFeed();
          },
          { rootMargin: '800px 0px' }
        );
        this.feedObserver.observe(this);
      }

      async loadFeed() {
        const posts = await this.fetchPosts().catch(() => []);
        if (!posts.length || !this.isConnected) return;
        this.renderPosts(posts);
      }

      async fetchPosts() {
        const cacheKey = `${FEED_CACHE_PREFIX}${this.dataset.feedUrl}`;
        const cached = readCache(cacheKey);
        if (cached) return cached;

        // Instafeed caches answers per URL, a 401 included, so one bad-key request
        // to the same URL can hide a working key for a while. Retry once with a
        // fresh URL; a really wrong key still gets 401.
        const url = this.dataset.feedUrl;
        const first = await requestFeed(url, this.dataset.feedKey);
        const json = first?.meta?.code === 401 ? await requestFeed(`${url}&_=${Date.now()}`, this.dataset.feedKey) : first;

        // Errors also come back as HTTP 200; the real status is meta.code
        // (202 = feed still building, 401 = bad key, 404 = not connected).
        if (json?.meta?.code !== 200 || !Array.isArray(json.data)) return [];

        const posts = json.data.map(toPost).filter(Boolean);
        if (posts.length) writeCache(cacheKey, posts);
        return posts;
      }

      renderPosts(posts) {
        const template = this.querySelector('template[data-feed-card]');
        if (!template) return;

        const cards = posts.map((post) => this.buildCard(template, post));
        const revealPending = this.scroller.hasAttribute('data-reveal-pending');
        this.scroller.replaceChildren(...cards);
        this.watchVideos(cards);
        // card-reveal.js hasn't played its entrance yet; it animates the new cards.
        if (revealPending) return;
        cards.forEach(showCard);
      }

      buildCard(template, post) {
        const card = template.content.firstElementChild.cloneNode(true);
        card.querySelector('a').href = post.link;
        const photo = card.querySelector('img');
        photo.src = post.image;
        photo.alt = post.alt || this.dataset.feedAlt || '';

        const video = card.querySelector('video');
        if (!post.video || !videoAllowed()) {
          video.remove();
          return card;
        }
        video.dataset.src = post.video;
        video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
        return card;
      }

      // Reels download only when their card is almost on screen, then play
      // while mostly visible and pause once scrolled away, so the homepage
      // never pulls every video up front.
      watchVideos(cards) {
        const videos = cards.map((card) => card.querySelector('video')).filter(Boolean);
        if (!videos.length) return;

        this.videoLoader = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.videoLoader.unobserve(entry.target);
              loadVideo(entry.target);
            });
          },
          { rootMargin: VIDEO_PRELOAD_MARGIN }
        );

        this.videoPlayer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.intersectionRatio < VIDEO_PLAY_RATIO) {
                video.pause();
                return;
              }
              loadVideo(video);
              // Autoplay can still be refused (e.g. low-power mode); the cover photo stays.
              video.play().catch(() => {});
            });
          },
          { threshold: [0, VIDEO_PLAY_RATIO] }
        );

        videos.forEach((video) => {
          this.videoLoader.observe(video);
          this.videoPlayer.observe(video);
        });
      }

      onPointerDown(event) {
        // Leave touch to native scrolling; only drag with the primary mouse button.
        if (event.pointerType === 'touch' || event.button !== 0) return;
        this.isDown = true;
        this.moved = false;
        this.startX = event.clientX;
        this.startScroll = this.scroller.scrollLeft;
        this.scroller.classList.add('is-dragging');
        this.scroller.addEventListener('pointermove', this.onPointerMove);
        this.scroller.addEventListener('pointerup', this.onPointerUp);
        this.scroller.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(event) {
        if (!this.isDown) return;
        const dx = event.clientX - this.startX;
        if (Math.abs(dx) > 5 && !this.moved) {
          this.moved = true;
          // Capture only once a real drag starts — capturing on pointerdown
          // retargets the click to the scroller, so card links never fire.
          this.scroller.setPointerCapture(event.pointerId);
        }
        this.scroller.scrollLeft = this.startScroll - dx;
      }

      onPointerUp(event) {
        if (!this.isDown) return;
        this.isDown = false;
        this.scroller.classList.remove('is-dragging');
        try {
          this.scroller.releasePointerCapture(event.pointerId);
        } catch (e) {
          /* pointer already released */
        }
        this.scroller.removeEventListener('pointermove', this.onPointerMove);
        this.scroller.removeEventListener('pointerup', this.onPointerUp);
        this.scroller.removeEventListener('pointercancel', this.onPointerUp);
      }

      onClick(event) {
        // Swallow the click that ends a drag so links don't fire mid-drag.
        if (this.moved) {
          event.preventDefault();
          event.stopPropagation();
          this.moved = false;
        }
      }
    }

    customElements.define('socials-gallery', SocialsGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terms-of-sale"] && !Shopify.designMode) return;
  try {
    
  /*
    Keep the sticky table of contents clear of the sticky navbar: measure the pinned
    header's height and expose it as --tos-header-offset on the section. Falls
    back to 0 when the header isn't sticky, so the column just uses the
    configured top gap. Mirrors the same helper in about-faq / main-product.
  */
  (function () {
    function syncTermsOffset() {
      var header = document.querySelector('[data-header-sticky]');
      var height = header ? Math.round(header.getBoundingClientRect().height) : 0;
      document.querySelectorAll('.tos').forEach(function (section) {
        section.style.setProperty('--tos-header-offset', height + 'px');
      });
    }

    if (document.querySelector('.tos')) {
      syncTermsOffset();
      window.addEventListener('resize', syncTermsOffset);
      window.addEventListener('load', syncTermsOffset);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('text-marquee-element')) {
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    class TextMarqueeElement extends HTMLElement {
      connectedCallback() {
        if (this.observed) return;
        this.observed = true;

        // Reduced motion: no clones, no animation, one static bar.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // Defer until the marquee nears the viewport. Concept uses Motion.inView
        // with this exact margin; IntersectionObserver is the equivalent.
        this.io = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.io.disconnect();
              this.io = null;
              this.init();
            }
          },
          { rootMargin: '200px 0px 200px 0px' }
        );
        this.io.observe(this);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.pauseObserver) this.pauseObserver.disconnect();
        if (this.scrollTrigger) this.scrollTrigger.kill();
        if (this.drift) this.drift.kill();
      }

      get childElement() {
        return this.firstElementChild;
      }

      get speed() {
        return this.hasAttribute('data-speed') ? parseInt(this.getAttribute('data-speed')) : 16;
      }

      get direction() {
        return this.hasAttribute('data-direction') ? this.getAttribute('data-direction') : 'left';
      }

      // Parallax is desktop-only; on touch the marquee falls back to the plain
      // loop plus the offscreen pause.
      get parallax() {
        return !isTouch && this.hasAttribute('data-parallax') ? parseFloat(this.getAttribute('data-parallax')) : false;
      }

      getWidth(element) {
        const rect = element.getBoundingClientRect();
        return rect.right - rect.left;
      }

      get parentWidth() {
        return this.getWidth(this);
      }

      get childElementWidth() {
        return this.getWidth(this.childElement);
      }

      get maximum() {
        if (this.hasAttribute('data-maximum')) return parseInt(this.getAttribute('data-maximum'));
        if (!this.childElementWidth) return 2;
        return Math.ceil(this.parentWidth / this.childElementWidth) + 2;
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        let duration = 26;

        if (this.childElementCount === 1) {
          this.childElement.classList.add('animated');

          const maximum = this.maximum;
          for (let index = 0; index < maximum; index++) {
            const clone = this.childElement.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('button, [href]').forEach((el) => {
              el.setAttribute('tabindex', '-1');
            });
            this.appendChild(clone);
          }

          // Longer strips get a proportionally longer loop, capped at 2.5x, so a
          // wide bar does not whip past. data-speed is inverted: higher = faster.
          const scale = Math.min(2.5, Math.ceil(this.childElementWidth / this.parentWidth));
          duration = (33 - this.speed) * scale;
          this.style.setProperty('--duration', `${duration}s`);
        }

        // Baseline travel direction. RTL flips it, same as --transform-logical.
        this.baseSign = this.direction === 'right' ? -1 : 1;
        if (document.documentElement.dir === 'rtl') this.baseSign *= -1;

        const hasGsap = Boolean(window.gsap);

        if (hasGsap) {
          // Same -100% -> -200% travel as the keyframes, but as a tween so the
          // playback direction can be reversed by sign-flipping timeScale.
          this.drift = window.gsap.fromTo(
            this.querySelectorAll('.marquee-bar'),
            { xPercent: -100 },
            { xPercent: -200, ease: 'none', duration: duration, repeat: -1 }
          );
          // Seek off the zero boundary so a negative timeScale has somewhere to
          // rewind into on the very first upward scroll.
          this.drift.progress(0.5);
          this.drift.timeScale(this.baseSign);
        } else {
          this.classList.add('marquee--css');
        }

        if (this.parallax && hasGsap && window.ScrollTrigger) {
          window.gsap.registerPlugin(window.ScrollTrigger);

          let translate = (this.parallax * 100) / (1 + this.parallax);
          translate = translate * this.baseSign;

          const tween = window.gsap.fromTo(
            this,
            { xPercent: translate },
            {
              xPercent: 0,
              ease: 'none',
              scrollTrigger: {
                trigger: this,
                start: 'top bottom', // section top hits viewport bottom
                end: 'bottom top', // section bottom leaves viewport top
                scrub: true,
                // self.direction: 1 while scrolling down, -1 while scrolling up.
                // Flipping the drift's sign with it makes the two directions
                // carry identical speed — drift and parallax now always add,
                // never subtract. When scrolling stops the drift keeps its last
                // direction and the parallax term simply rests.
                onUpdate: (self) => {
                  if (this.drift) this.drift.timeScale(this.baseSign * self.direction);
                },
              },
            }
          );
          this.scrollTrigger = tween.scrollTrigger;
        } else {
          // No parallax → stop the loop entirely while offscreen.
          this.pauseObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (this.drift) {
                  entry.isIntersecting ? this.drift.play() : this.drift.pause();
                }
                this.classList.toggle('paused', !entry.isIntersecting);
              });
            },
            { rootMargin: '0px 0px 50px 0px' }
          );
          this.pauseObserver.observe(this);
        }
      }
    }

    customElements.define('text-marquee-element', TextMarqueeElement);
  }

  } catch(e) { console.error(e); }
})();
})();
